<template>
  <div id="form" :style="`--data-themecolor:white`">
    <div class="row no-margins">
       <div class="input-field col s12 m6">
         <input type="text"
         class="validate"
         :disabled="true" :value="authUser.first_name" 
     
          name="first_name" id="first_name">
         <label for="first_name" class="active">First Name</label>
      
       </div>
        <div class="input-field col s12 m6">
         <input type="text" :disabled="true" :value="authUser.last_name" name="last_name" id="last_name">
         <label for="last_name" class="active">Last Name</label>
       </div>
        <div class="input-field col s12 ">
         <input type="email"  
          :class="[$v.user.email.$invalid ? 'invalid' : 'valid']"
           v-model="user.email" name="email" id="email">
         <label for="email">Email</label>
            <span class="helper-text"
            data-error="Valid email address required" 
            data-success="Address Vaild"
          >Valid email address required</span>
       </div>
        <div class="input-field col s12">
          <textarea class="materialize-textarea" 
           :class="[$v.user.message.$invalid ? 'invalid' : 'valid']"
          name="message" id="message" v-model="user.message"  style="min-height:120px;"></textarea>
          <label for="message">Enter Message</label>
           <span class="helper-text"
            data-error="A message is required" 
            :data-success="`Vaild `"
          >Field cannot be empty</span>
        </div>
        <div class="col s12">
        <button @click="$_submit()" :disabled="!validate" class="btn blue accent-4 s12 col waves-effect">Send Message</button>
        </div>
    </div>
  </div>
</template>
<script>
import M from 'materialize-css'

import {minLength, email, required} from 'vuelidate/lib/validators'
import formsService from '@/services/formService.js'
export default {
  props: {
    submission:{
      type:[Object, Boolean],
    },
    dataForm: {
      type: String,
    },
    authUser:{
      type: Object
    }
  },
  name:'contactForm',
  data(){
    return {
   // eslint-disable-line
    reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/, 
    user:{
      first_name:'',
      last_name: '',
      email: this.authUser.email,
      message: '',
    },
    }
  },
  validations () {
    return { 
      user: {
       message: {
        required,
        minLenth:minLength(16)
      },
      email: {
        email, required
      }
      },
    }
  },
  computed: {
    validate:{
      get () {
        return !this.$v.$invalid
      }
    }
  },
  methods:{
  isEmailValid: function() {
    return (this.user.email === "")? "" : (this.reg.test(this.user.email)) ? true : false ;
  },
  $_returnToNav(){
    this.$emit('status','nav')
  },
  $_submit(){

    /* "first_name",
    "last_name",
    "company",
    "telephone",
    "email",
    "your-subject",
    "message", */
  

    let payload = {
        first_name: this.authUser.first_name,
        last_name: this.authUser.last_name,
        subject: `Stats Submission questions`,
        id:  this.submission.id,
        form: this.dataForm,
        email: this.user.email,
        message: this.user.message,
        _wpcf7_unit_tag:"7eba150"
    }
/*     let formData = new FormData()

    formData.append('first_name',this.user.first_name);
    formData.append('last_name',this.user.last_name);
    formData.append('subject',`Stats Submission questions`);
    formData.append('id', this.submission.id);
    formData.append('form', this.dataForm);
    formData.append('email',this.user.email);
    formData.append('message', this.user.message); */

    formsService.newRequest(payload, 217)
    .then(()=>{
    
        M.toast({html:`Got it We'll talk soon :)`})
        this.user = {}
        this.$emit('status', 'nav')
    
    })
    .catch(()=>{

    })
  },
}
}
</script>
<style lang="scss" scoped>
#form {
  padding:24px;
  .form-title {
    font-size: 21px;
    line-height: 39px;
    margin-left: 8px;
    float: left;
  }
}
</style>